import styles from './HamadoriHeadline.module.scss';
import stamp_img from './images/hamadori-stamp.svg';
import wave_img from './images/wave.svg';

type HamadoriHeadlineProps = React.PropsWithChildren<{
  className?: string;
}>;
export const HamadoriHeadline = ({ children, className }: HamadoriHeadlineProps) => {
  return (
    <div className={`${styles.hamadoriHeadline} ${className}`}>
      <img src={wave_img} alt="" className={styles.wave} />
      <div className={styles.headLineInner}>
        <img src={stamp_img} alt="" className={styles.stamp} />
        {children}
      </div>
      <img src={wave_img} alt="" className={styles.wave} />
    </div>
  );
};
